import {useEffect, useReducer, createContext, ActionDispatch} from 'react';
import {NotificationContextInterface} from '../types/common';
import {ToastComponent} from '../components';

interface AddNotificationAction {
    type: "ADD_NOTIFICATION";
    payload: Omit<NotificationContextInterface, "id">;
}

interface RemoveNotificationAction {
    type: "REMOVE_NOTIFICATION";
    payload: { id: number };
}

type ActionNotificationActionType =
    | AddNotificationAction
    | RemoveNotificationAction;

const initials: NotificationContextInterface[] = [
    {
        message: 'Sample 1',
        title: 'Title 1',
        id: Date.now() + 1,
    },
    {
        message: 'Sample 2',
        title: 'Title 2',
        id: Date.now() + 2,
    }, {
        message: 'Sample 3',
        title: 'Title 3',
        id: Date.now() + 3,
    },
];


const reducer = (state: NotificationContextInterface[], action: ActionNotificationActionType): NotificationContextInterface[] => {
    switch (action.type) {
        case "ADD_NOTIFICATION":
            const id = Date.now();
            const next = [{
                id: id,
                title: action.payload.title,
                status: action.payload.status,
                message: action.payload.message
            }, ...state]
            if (next.length > NOTIFICATION_MAX_LENGTH) {
                next.pop()
            }
            return next;
        case "REMOVE_NOTIFICATION":
            return state.filter(i => i.id !== action.payload.id);
        default:
            return state;
    }
}
export const NotificationContext = createContext<{
    notifications: NotificationContextInterface[];
    dispatch: ActionDispatch<[action: ActionNotificationActionType]>
} | null>(null);

export const NOTIFICATION_MAX_LENGTH = 3;
export const NotificationProvider = ({children}: { children: any }) => {
    const [notifications, dispatch] = useReducer(reducer, [])
    useEffect(() => {
        const interval = setInterval(() => {
            // eslint-disable-next-line array-callback-return
            notifications.map((prev) => {
                if ((Date.now() - prev.id) > 10000) {
                    dispatch({type: "REMOVE_NOTIFICATION", payload: {id: prev.id}})
                }
            })
        }, 1000)
        return () => clearInterval(interval)
    }, [notifications])
    return (
        <NotificationContext.Provider value={
            {
                notifications,
                dispatch
            }
        }>
            <ToastComponent/>
            {children}
        </NotificationContext.Provider>
    );
};